// Drizzle-free constants safe to import from the frontend bundle (no pg-core).
// Single source of truth for enum-like lists that both the DB schema and the
// UI need — the Drizzle pgEnums derive from these, so a dropdown can never
// drift from the column type (TK-135).

export const ACCOUNT_KINDS = [
  "bank",
  "broker",
  "cash",
  "other_investment",
  "income_source",
  "credit_card",
  "loan",
] as const;

export type AccountKindConst = (typeof ACCOUNT_KINDS)[number];

/**
 * Kinds the user manages by hand — no external balance feed, so their balance
 * is a ledger derived from transactions and their opening balance is a real
 * "Opening balance" deposit (TK-138). Extensible; starts at `cash`.
 */
export const MANUAL_ACCOUNT_KINDS = ["cash"] as const satisfies readonly AccountKindConst[];

export function isManualAccountKind(kind: string): boolean {
  return (MANUAL_ACCOUNT_KINDS as readonly string[]).includes(kind);
}

/**
 * Time windows of the portfolio dashboard (FT-70). One list: the analytics API
 * validates `?period=` against it and the UI renders its selector from it.
 */
export const PORTFOLIO_PERIODS = ["1M", "3M", "6M", "YTD", "1Y", "ALL"] as const;

export type PortfolioPeriodConst = (typeof PORTFOLIO_PERIODS)[number];

export const DEFAULT_PORTFOLIO_PERIOD: PortfolioPeriodConst = "3M";

/**
 * The portfolio dashboard's panels (FT-70). Each is served at
 * `/analytics/portfolio/<panel>`; the API registers its routes from this list
 * and the web app keys its queries by it.
 */
export const PORTFOLIO_PANELS = ["summary", "allocation", "performance", "movers", "income"] as const;

export type PortfolioPanelConst = (typeof PORTFOLIO_PANELS)[number];

/** The ways the allocation panel can slice the portfolio (FT-70). */
export const ALLOCATION_DIMENSIONS = ["asset_class", "currency", "broker", "account"] as const;

export type AllocationDimensionConst = (typeof ALLOCATION_DIMENSIONS)[number];

/**
 * Spending summary windows, each from its start until now. One list: the
 * analytics package sums by it, the REST response and the MCP tool validate it.
 */
export const SPENDING_PERIODS = ["daily", "weekly", "monthly", "yearly"] as const;

export type SpendingPeriodConst = (typeof SPENDING_PERIODS)[number];
